var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { onDownPreventDefault } from './../utils';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { messages } from './../../messages';
import { InsertTablePopupNS } from './popup';
import { canInsert, createTable, insertNode } from '@progress/kendo-editor-common';
/**
 * @hidden
 */

export var InsertTableToolNS;

(function (InsertTableToolNS) {
  /**
   * @hidden
   */
  InsertTableToolNS.createInsertTableTool = function (settings) {
    var Tool = function (_super) {
      __extends(InsertTableTool, _super);

      function InsertTableTool() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.state = {
          openedPopup: false
        };
        _this.button = null;

        _this.togglePopup = function () {
          _this.setState({
            openedPopup: !_this.state.openedPopup
          });
        };

        _this.closePopup = function () {
          if (_this.state.openedPopup) {
            _this.togglePopup();
          }
        };

        _this.onTableInsert = function (row, col) {
          var view = _this.props.view;

          if (!view) {
            return;
          }

          var newTable = createTable(view.state.schema.nodes, row, col);

          if (newTable) {
            insertNode(newTable, true)(view.state, view.dispatch);
          }

          view.focus();

          _this.closePopup();
        };

        return _this;
      }

      InsertTableTool.prototype.render = function () {
        var _this = this;

        var _a = this.props,
            view = _a.view,
            render = _a.render,
            props = __rest(_a, ["view", "render"]);

        var state = view && view.state;
        var localization = provideLocalizationService(this);
        var _b = settings.messages,
            createTableMsgKey = _b.createTable,
            createTableHint = _b.createTableHint;
        var createTableMsg = localization.toLanguageString(createTableMsgKey, messages[createTableMsgKey]);
        var createTableHintMsg = localization.toLanguageString(createTableHint, messages[createTableHint]);
        var rendering = [React.createElement(Button, __assign({
          onClick: this.togglePopup,
          ref: function ref(e) {
            return _this.button = e && e.element;
          },
          key: "InsertTable",
          disabled: !state || !canInsert(state, state.schema.nodes.table)
        }, onDownPreventDefault, {
          title: createTableMsg
        }, settings.props, props)), view && React.createElement(InsertTablePopupNS.InsertTablePopup, {
          key: "insertTablePopup",
          createTableMessage: createTableMsg,
          createTableHintMessage: createTableHintMsg,
          dir: props.dir,
          anchor: this.button,
          show: this.state.openedPopup,
          onClose: this.closePopup,
          onTableInsert: this.onTableInsert
        }) || null];
        return render ? render.call(undefined, rendering, {
          view: view
        }) : rendering;
      };

      return InsertTableTool;
    }(React.Component);

    registerForLocalization(Tool);
    return Tool;
  };
})(InsertTableToolNS || (InsertTableToolNS = {}));